import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'
import { useTranslation } from '../../../lib/locales'
import { LanguagesIcon } from 'lucide-react'
import { useLingui } from '@lingui/react/macro'

export function LanguageSelector() {
  const { t } = useLingui()
  const { language, changeLanguage, languages } = useTranslation()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline">
          <LanguagesIcon />
          {languages[language]}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>{t`Select a Language`}</DropdownMenuLabel>
        <DropdownMenuRadioGroup value={language} onValueChange={changeLanguage}>
          {Object.entries(languages).map(([code, label]) => (
            <DropdownMenuRadioItem key={code} value={code} onClick={() => changeLanguage(code)}>
              {label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
